module.exports = __webpack_public_path__ + "img/logo-sc-azul.c02f2294.png";